import client from './api-client';

// Informe Inicial de Defensa Penal (RG-576). El perfil y la identidad los calcula el servidor desde el token;
// el front nunca los envía.

// Escritura (API Externos, post): guardar borrador y enviar / actualizar. body = { accion: 'BORRADOR' | 'ENVIAR', idCaso, idInforme, informe }.
// El servidor responde code 1 en éxito; code 11 (validación) o -1 se devuelven como Error con el mensaje del servidor.
export const serviceRegistraInformePenal = async (body) => {
    try {
        const response = await client.post('gestion-implicado/informe-defensa-penal', body);

        if (response.status === 200 && response.data.code === 1) return response.data
        else {
            // El código del servidor (11 = validación / regla de negocio, -1 = error) viaja con el error para que el aviso elija su color.
            const error = new Error(response.data.message);
            error.code = response.data.code;
            throw error;
        }
    }
    catch (error) {
        throw error;
    }
}

// Lectura (API Internos, getSelect). query = base64 de { modo: 'ultimo', idCaso }.
export const serviceGetInformePenal = async (query) => {
    try {
        const response = await client.getSelect(`consulta/informe-defensa-penal?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}
